import { Bar, BarChart, XAxis, ResponsiveContainer } from 'recharts'
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/components/ui/chart'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

const chartData = [
  { month: 'Jan', revenue: 1860 },
  { month: 'Fev', revenue: 3050 },
  { month: 'Mar', revenue: 2370 },
  { month: 'Abr', revenue: 1730 },
  { month: 'Mai', revenue: 2090 },
  { month: 'Jun', revenue: 3140 },
  { month: 'Jul', revenue: 2800 },
]

const chartConfig = {
  revenue: {
    label: 'Receita (€)',
    color: 'hsl(var(--primary))',
  },
} satisfies ChartConfig

export const RevenueChart = () => {
  return (
    <Card className="col-span-4 lg:col-span-3 shadow-sm border-slate-200/60 bg-white">
      <CardHeader>
        <CardTitle className="text-base font-semibold text-slate-900">
          Receita ao longo do tempo
        </CardTitle>
      </CardHeader>
      <CardContent className="pl-2">
        <ChartContainer config={chartConfig} className="h-[250px] w-full">
          <BarChart data={chartData}>
            <XAxis
              dataKey="month"
              stroke="#888888"
              fontSize={12}
              tickLine={false}
              axisLine={false}
            />
            <ChartTooltip
              cursor={{ fill: 'hsl(var(--muted))' }}
              content={<ChartTooltipContent />}
            />
            <Bar
              dataKey="revenue"
              fill="currentColor"
              radius={[4, 4, 0, 0]}
              className="fill-primary"
            />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  )
}
